import * as React from 'react';
import { motion } from 'framer-motion';

type Props = {
  opened: boolean;
  children: React.ReactNode;
  style?: Record<string, string>;
};

/**
 * Анимация высоты.
 * Пока закрыт и пока идёт анимация — overflow hidden (иначе дети раздувают
 * scroll родителя). После открытия — visible, чтобы не резать box-shadow
 * у инпутов/селекторов внутри (как на странице настроек без Collapsed).
 */
const Collapsed: React.FC<Props> = ({ opened, children, style }: Props) => {
  const [overflowVisible, setOverflowVisible] = React.useState(opened);

  React.useEffect(() => {
    if (!opened) {
      setOverflowVisible(false);
    }
  }, [opened]);

  const variants = {
    opened: {
      height: 'auto',
      opacity: 1
    },
    closed: {
      height: 0,
      opacity: 0
    }
  };

  const handleAnimationComplete = React.useCallback(() => {
    if (opened) {
      setOverflowVisible(true);
    }
  }, [opened]);

  return (
    <motion.div
      style={{
        ...style,
        overflow: overflowVisible ? 'visible' : 'hidden'
      }}
      initial={false}
      animate={opened ? 'opened' : 'closed'}
      variants={variants}
      onAnimationComplete={handleAnimationComplete}
    >
      {children}
    </motion.div>
  );
};

export default Collapsed;
